import React, { useState, useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import NewSidebar from "./Sidebar/NewSidebar";
import "./NewappLayout.scss";
import { Snackbar, Alert } from "@mui/material";
import { clearErrors } from "../../Redux/ActionCreators/errorAction";
import { useSelector, useDispatch } from "react-redux";

const AppLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    window.innerWidth < 767
  );
  const [notification, setNotification] = useState(null);
  const [notificationTrigger, setNotificationTrigger] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };
  const error = useSelector((state) => state.error);
  const dispatch = useDispatch();
  const socketRef = useRef(null);

  const snackClosed = () => {
    dispatch(clearErrors());
  };

  useEffect(() => {
    const scriptId = "bitrix-chatbot-script";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.src =
        "https://cdn.bitrix24.in/b33556685/crm/site_button/loader_3_q0ukyu.js?" +
        ((Date.now() / 60000) | 0);
      document.body.appendChild(script);
    }

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const tenantId = localStorage.getItem('tenentId');
    const baseUrl = process.env.REACT_APP_WS_URL;

    if (!token || !tenantId || !baseUrl) return;

    const wsUrl = `${baseUrl}?token=${encodeURIComponent(token)}`;

    const socket = new WebSocket(wsUrl);
    socketRef.current = socket;

    socket.onopen = () => {
      const joinMessage = { action: 'join', group: `tenant-${tenantId}` };
      socket.send(JSON.stringify(joinMessage));
    };

    socket.onmessage = (event) => {
      try {
        const parsed = JSON.parse(event.data);

        if (parsed.type === 'notification') {
          // toast.success("You got a new notification", { autoClose: 3000 });
          setNotificationTrigger(prev => !prev);
        }
      } catch (err) {
        console.error('Error parsing WebSocket message:', err);
      }
    };

    socket.onclose = () => console.warn('WebSocket disconnected');
    socket.onerror = (err) => console.error('WebSocket error:');

    return () => {
      if (socketRef.current) socketRef.current.close();
    };
  }, []);

  const isMobile = window.innerWidth < 767;


  return (
    <div className="app-layout">
      {!isMobile && (
      <NewSidebar
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={error.successMessage}
        autoHideDuration={3000}
        onClose={snackClosed}
      >
        <Alert onClose={snackClosed} severity="error" sx={{ width: "100%" }}>
          {error.successMessageText}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={error.successEnable}
        onClose={() => snackClosed()}
        autoHideDuration={3000}
      >
        <Alert onClose={snackClosed} severity="success" sx={{ width: "100%" }}>
          {error.successMessageText}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={Boolean(notification)}
        autoHideDuration={3000}
        onClose={() => setNotification(null)}
      >
        <Alert onClose={() => setNotification(null)} severity="info" sx={{ width: '100%' }}>
          {notification}
        </Alert>
      </Snackbar>
      <div className="main-content">
        <div className="page-content">
          <Outlet context={{ notificationTrigger }} />
        </div>
        {isMobile && (
          <div className="mobile-sidebar">
            <NewSidebar
              isCollapsed={false}
              toggleSidebar={toggleSidebar}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AppLayout;
